const validateMixin = {
  methods: {
    addError (errorObject, scope = '') {
      let field = this.$validator.fields.find({ name: errorObject.field, scope: this.$options.scope || scope || '' })

      console.log(field, this.$validator.fields)

      this.$validator.errors.add({
        id: field.id,
        field: errorObject.field,
        msg: errorObject.message,
        scope: this.$options.scope || scope || ''
      })

      field.setFlags({
        invalid: true,
        valid: false,
        validated: true
      })
    }
  }
}

export default validateMixin
